const PrimaryLoader = () => {
    return (
      <div className="horizontal-bar-wrap">
        <div className="bar1 bar"></div>
      </div>
    )
  }
  
  export default PrimaryLoader